import { action } from 'satcheljs/lib/legacy';
import datapoints from '../datapoints';
import densityOptionSelectedValue from '../utils/densityOptionSelectedValue';
import getDensityOptionState from '../store/store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { logUsage } from 'owa-analytics';
import { saveDensityModeFromFullSettingsService } from '../services/saveDensityModeService';

export default action('saveDensityOptionFullSettings')(
    async function saveDensityOptionFullSettings() {
        // From full settings only the messasge height will be changed, user needs to manually turn off features if needed
        const densityOptionSelected = getDensityOptionState().densityModeSelected;
        getUserConfiguration().UserOptions.DisplayDensityMode = densityOptionSelected;

        // For Datapoints logging
        const {
            name: eventName,
            customData: customData,
        } = datapoints.DisplayDensityFullSettings.datapoint;
        logUsage(eventName, customData(densityOptionSelected));

        const densityOptionValue = densityOptionSelectedValue(densityOptionSelected);
        await saveDensityModeFromFullSettingsService(densityOptionValue);
    }
);
